/*
 * Copyright (C) 2025 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

const scoreFromPercent = (percent, outcome, pointsPossibleFromOutcomeRatingsFromRubric) => {
  const points_possible =
    typeof pointsPossibleFromOutcomeRatingsFromRubric === 'number' &&
    pointsPossibleFromOutcomeRatingsFromRubric > 0
      ? pointsPossibleFromOutcomeRatingsFromRubric
      : outcome.points_possible

  if (points_possible > 0) {
    return +(percent * points_possible).toFixed(2)
  } else {
    return +(percent * outcome.mastery_points).toFixed(2)
  }
}

const scaleScore = (score, possible, outcome, pointsPossibleFromOutcomeRatingsFromRubric) => {
  if (!possible) return score
  const points_possible =
    typeof pointsPossibleFromOutcomeRatingsFromRubric === 'number' &&
    pointsPossibleFromOutcomeRatingsFromRubric > 0
      ? pointsPossibleFromOutcomeRatingsFromRubric
      : outcome.points_possible

  if (points_possible > 0) {
    return +((score / possible) * points_possible).toFixed(2)
  } else {
    return +((score / possible) * outcome.mastery_points).toFixed(2)
  }
}

export {scoreFromPercent, scaleScore}
